import { logEvent } from "firebase/analytics";
import { analytics } from "../Services/firebase";

const openInfoGuide = () => {
  logEvent(analytics, "open_info_guide");
};

export {openInfoGuide};
